import React from 'react';
import Clock from 'react-live-clock';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    text: {
        marginRight: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            marginRight: theme.spacing(10),
        }
    }

}))

const DevicesOnline = (props) => {

    const classes = useStyles();
    const { devicesOnline } = props;

    return (
        <span className={classes.text}>
            <Clock ticking={true} format={'dddd Do MMMM YYYY | HH:mm | '} /> {devicesOnline} {devicesOnline === 1 ? " device online" : " devices online"}
        </span>
    );
}

export default DevicesOnline;